<template>
    <div>
        <div class="knd-paragraaf__tekst knd-wrapper knd-m-auto knd-my-5">
            <div class="" v-html="output_text(content.tekst, this)"></div>
        </div>

        <div class="knd-paragraaf__image knd-wrapper knd-m-auto knd-my-5" v-if="content.afbeelding?.length >0 ">
          <img
            class="pic"
            :src="'https://pointer-dev.kro-ncrv.nl/' + content.afbeelding[0].url"
          >        
        </div>
    </div>
</template>

<script>
    import {output_text} from '../utils/main';

    export default {
        props: {
            content: {
                type: Object
            }
        },
        data() {
            return {
                output_text: output_text
            }
        },
    }
</script>

<style lang="scss" scoped>

.knd-paragraaf__tekst {
    margin-top: 2rem;
}
.knd-paragraaf__image {
    img {
        margin: 0 auto;
    }
}

</style>